import styled from 'styled-components';
import { media } from 'src/components/base';
import InfoPageLink from '../../../../components/info-page-link';

export const StyledPriceInformation = styled.div`
  display: flex;
  width: 100%;
  color: $text-color-lighten;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: none;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: space-between;
  ${media.mediumUp`
    flex-direction: row;
  `}
`;

export const StyledInfoPageLinkWrapper = styled.div`
  display: flex;
  color: inherit;
  text-decoration: underline;
  align-items: baseline;
`;

export const StyledInfoPageLink = styled(InfoPageLink)`
  &:hover {
    color: ${p => p.theme.colors.maybeBlue700};
  }
`;
